export default {
  reward_title: "邀請獎勵",
  reward_desc_dynamic: "每成功邀請一位朋友註冊，您將獲得 {0} 次計算點數作為獎勵",
  invite_friend: "邀請朋友",
  friend_email: "朋友的電子郵箱",
  email_placeholder: "請輸入朋友的電子郵箱",
  send_invite: "發送邀請",
  invite_instructions: "邀請說明",
  email_invitation_validity_dynamic: "電子郵箱邀請有效期為 {0} 天",
  link_invitation_permanent: "連結邀請永久有效",
  instruction_1_dynamic: "每次成功邀請，您和朋友各獲得 {0} 次計算點數",
  instruction_2: "獎勵在朋友接受邀請並成功註冊後自動發放",
  instruction_3: "獎勵點數可用於碳排放計算，有效期根據您的訂閱方案而定",
  invite_stats: "邀請統計",
  total_invites: "總邀請數",
  accepted_invites: "已接受邀請",
  reward_credits: "獎勵點數",
  invite_link: "個人邀請連結",
  reward_rules: "獎勵規則",
  reward_rule_1_dynamic: "每次成功邀請，您將獲得 {0} 次計算點數作為獎勵",
  reward_rule_2: "獎勵點數會自動發放到您的帳戶，可用於碳排放計算",
  reward_rule_3: "如發現欺詐行為，我們保留取消獎勵和封鎖帳戶的權利",
  email_required: "請輸入電子郵箱地址",
  email_invalid: "電子郵箱格式無效",
  invite_sent: "邀請已發送",
  send_failed: "邀請發送失敗",
  fetch_failed: "獲取邀請資訊失敗",
  copy_success: "複製成功",
  email_invitation: "電子郵箱邀請",
  link_invitation: "連結邀請",
  status_pending: "待處理",
  status_accepted: "已接受",
  status_expired: "已過期",
  reward_issued: "已發放",
  pending: "待處理",
  reward_pending_tip: "獎勵將在朋友完成首次計算後發放",
  expiring_soon: "即將過期",
  no_invitations: "無邀請記錄",
  invitee_id: "受邀者 ID",
  type: "邀請類型",
  email: "電子郵箱",
  status: "狀態",
  reward_status: "獎勵狀態",
  invite_time: "邀請時間",
  expire_time: "到期時間",
  my_invitations: "我的邀請",
  invite_created_title: "邀請連結",
  invite_created_desc: "無法發送電子郵件。請手動將以下連結發送給您的朋友：",
  total_invitations: "共 {0} 條記錄",
  search_invitations: "搜尋邀請...",
  confirm: "確認",
};
